

export const genfilterConfig = ({ contentTypes, allTpls }) => {
    return[
        {
        filterId: "contentType",
        display: "Content Type",
        source: {
            filterType: "staticType",
            options: allTpls
            .filter((d) => contentTypes.includes(d.kp_content_type))
            .map((d) => ({
                display: d.general.content.title,
                value: d.kp_content_type,
            })),
        },
        target: {
            filterType: "staticType",
            valuePath: "meta.kp_content_type"
        },
        },
        {
            filterId: "dateFilter",
            display: "Published Date",
            source: {
                "filterType": "dateRangeType"
            },
            target: {
                filterType: "dateRangeType",
                valuePath: "kp_date_published"
            }
        },
        {
            filterId: "stakeholder",
            source: {
                filterType: "tagType",
                tagType: "stakeholder"
            },
            target: {
                filterType: "tagType",
                tagType: "stakeholder"
            },
        },
        {
            filterId: "subject",
            source: {
                filterType: "tagType",
                tagType: "subject"
            },
            target: {
                filterType: "tagType",
                tagType: "subject"
            },
        },
        {
            filterId: "country",
            source:{
                filterType: "tagType",
                tagType: "country",
            },
            target: {
                "filterType": "tagType",
                "tagType": "country"
            },
            },
        {
            filterId: "states",
            source: {
                filterOptionsBy: {
                filterId: "contentTagFilter_tagsCountry"
                },
                filterType: "tagType",
                tagType: "states"
            },
            target: {
                filterType: "tagType",
                tagType: "states"
            },
        },
        {
            filterId: "districts",
            source: {
                filterOptionsBy: {
                    filterId: "contentTagFilter_tagsStates"
                },
                filterType: "tagType",
                tagType: "districts"
            },
            target: {
                filterType: "tagType",
                tagType: "districts"
            },
        },
        {
            filterId: "facilityTypes",
            source: {
                filterType: "tagType",
                tagType: "facilityTypes"
            },
            target: {
                filterType: "tagType",
                tagType: "facilityTypes"
            },
        },
        {
            filterId: "conditionAreas",
            source: {
                filterType: "tagType",
                tagType: "conditionAreas"
            },
            target: {
                filterType: "tagType",
                tagType: "conditionAreas"
            },
        },
        {
            filterId: "teams",
            source: {
                filterType: "tagType",
                tagType: "teams"
            },
            target: {
                filterType: "tagType",
                tagType: "teams"
            },
        },
        // {
        //   filterId: '3',
        //   source: {
        //     filterType: 'tagType',
        //     tagType: 'facilityType'
        //   },
        //   target: {}
        // },
  ]}